import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { selectItemById, updateClassType, getClassTypeById } from 'app/redux/store/features/classTypes'
import UpdateClassTypeForm from './UpdateClassTypeForm'
import utilServices from 'app/services/util-services'

const UpdateClassType = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const [apiCallInProgress, setApiCallInProgress] = useState(false)
    const { state } = useLocation()
    const { id } = state
    const { classTypes, loading, error } = useSelector((state) => state.classTypes)
    const classType = selectItemById(classTypes, id)

    useEffect(() => {
        if (utilServices.isNullOrUndefined(classType.id)) dispatch(getClassTypeById({ id: id }))
    }, [])

    useEffect(() => {
        if (!apiCallInProgress || loading) return
        setApiCallInProgress(false)

        if (error) handleError(error)
        else {
            enqueueSnackbar('Class Type updated successfully', {
                variant: 'success',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
            navigate('/settings/definitions/class-types')
        }
    }, [loading])

    function handleError(error) {
        if (error.status === '401') {
            navigate('/profile/signout')
        } else if (error.detail) {
            enqueueSnackbar(error.detail, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        } else {
            enqueueSnackbar(error, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            })
        }
    }

    const onUpdateClassType = async () => {
        setApiCallInProgress(true)
        dispatch(updateClassType({ ...classType }))
    }

    return (
        <React.Fragment>
            <UpdateClassTypeForm classTypeData={classType} updateClassType={onUpdateClassType} />
        </React.Fragment>
    )
}

export default UpdateClassType
